var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"size":"small","bordered":false}},[_c('span',{staticStyle:{"margin-right":"8px"}},[_vm._v("时间:")]),_c('a-range-picker',{attrs:{"allow-clear":false},model:{value:(_vm.checkedDate),callback:function ($$v) {_vm.checkedDate=$$v},expression:"checkedDate"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }